const guildMemberRoleOptions = [
  {
    value: 'supporter',
    label: 'Supporter',
    icon: 'diversity_3',
    iconLibrary: 'material',
    description: 'FIXME',
    invitableBy: ['organizer', 'point'],
    requestable: true,
  },
  {
    value: 'contributor',
    label: 'Contributor',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'FIXMEs',
    invitableBy: ['organizer', 'point'],
    requestable: true,
  },
  { 
    value: 'organizer',
    label: 'Organizer',
    icon: 'crowdsource',
    iconLibrary: 'material',
    description: 'FIXME',
    invitableBy: ['point'],
    requestable: false,
  },
  {
    value: 'point',
    label: 'Point',
    icon: 'assistant_navigation',
    iconLibrary: 'material',
    description: 'FIXME',
    invitableBy: [],
    requestable: false,
  },
];
const guildMemberRoleMap = Object.fromEntries(guildMemberRoleOptions.map((o) => [o.value, o]));

/*=== EXPORTS ===*/

export {
  guildMemberRoleOptions,
  guildMemberRoleMap,
};
